import { Action, Location } from 'history';

// Initialized once
const routes: { path: string; callback?: () => void }[] = [
  { path: window.location.pathname },
];
window.past = routes;
window.currentLocation = {
  pathname: window.location.pathname,
  search: window.location.search,
  hash: '',
  state: {},
};

const TEMP_HISTORY_KEY = 'temp';

export function isLastPathTemp(): boolean {
  return window.past.slice(-1)[0]?.path === TEMP_HISTORY_KEY;
}

export function historian({
  fromEvent = true,
  action,
  location,
  callback,
}: {
  action: Action;
  location: Location;
  fromEvent?: boolean;
  callback?: () => void;
}): void {
  if (isLastPathTemp() && !fromEvent) return;

  const path = !fromEvent ? TEMP_HISTORY_KEY : location.pathname;

  if (action === 'POP') {
    const lastIndex = routes.pop();
    lastIndex?.callback?.();
  } else if (action === 'PUSH') {
    routes.push({ path, callback });
  } else {
    const lastIndex = routes.pop();
    lastIndex?.callback?.();
    routes.push({ path, callback });
  }

  window.past = routes;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (!(location.state as any)?.background) {
    window.currentLocation = location;
  }

  if (routes.length <= 1 && fromEvent) {
    window.dispatchEvent(new CustomEvent('shouldClose', { detail: true }));
  } else if (fromEvent) {
    window.dispatchEvent(new CustomEvent('shouldClose', { detail: false }));
  }
}
